import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

// counter
import { CountUpModule } from "ngx-countup";
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgApexchartsModule } from "ng-apexcharts";
import { SimplebarAngularModule } from "simplebar-angular";
import { CarouselModule } from "ngx-owl-carousel-o";
import { FeatherModule } from "angular-feather";
import { allIcons } from "angular-feather/icons";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";

import { SharedModule } from "../shared/shared.module";
import { WidgetModule } from "../shared/widget/widget.module";

import { PagesRoutingModule } from "./pages-routing.module";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { FaqComponent } from "./faq/faq.component";
import { UsersComponent } from "./users/pages/users/users.component";
import { CallCenterModule } from "./call-center/call-center.module";
import { ChatComponent } from "./chat/chat.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    DashboardComponent,
    ChatComponent
],
  imports: [
    CommonModule,
    WidgetModule,
    CountUpModule,
    SharedModule,
    NgApexchartsModule,
    PagesRoutingModule,
    SimplebarAngularModule,
    CallCenterModule,
    CarouselModule,
    FeatherModule.pick(allIcons),
    RouterModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbTooltipModule,
    LeafletModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [FeatherModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PagesModule {}
